import { getProjectPaymentTypeLabel } from './getProjectPaymentTypeLabel'
import type { ProjectPaymentType } from './projectPaymentType'
import { ProjectPaymentTypeTooltip } from './ProjectPaymentTypeTooltip'

type Props = {
  projectPaymentType: ProjectPaymentType
  isYieldCompounding?: boolean
}

export function ProjectPaymentTypeLabel({
  projectPaymentType,
  isYieldCompounding = false,
}: Props) {
  const paymentTypeLabel = getProjectPaymentTypeLabel(
    projectPaymentType,
    isYieldCompounding
  )
  return (
    <div className="flex items-center gap-2">
      {paymentTypeLabel}
      <ProjectPaymentTypeTooltip paymentTypeLabel={paymentTypeLabel} />
    </div>
  )
}
